<template>
  <!-- 列表弹出框 -->
  <div>
    <van-popup
      class="box"
      v-model="show"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="header">
        <span class="title">{{ header }}</span>
        <img @click="close" class="close-icon" src="../../../../assets/refund/down.png" alt="">
        <!-- <van-icon
          @click="close"
          size="12px"
          name="cross"
          color="#A2A3A4"
        /> -->
      </div>
      <div v-if="datalist.length > 0" class="person-list">
        <div
          v-for="(item, index) of datalist"
          :key="index"
          class="person-item"
          @click="selectItem(item)"
        >
          <span class="name">{{ item.name }}</span>
          <!-- <van-icon
            v-if="item.id === selItem.id"
            class="select-icon"
            color="#36B374"
            name="success"
          /> -->
          <img class="select-icon" v-if="item.id === selItem.id" src="../../../../assets/refund/icon_check@2x.png" alt="">

        </div>
      </div>
      <div v-else class="box1">
        <img src="../../../../assets/empty/ic_wuxingxi.png" />
        <p class="tip1">暂无数据</p>
      </div>
    </van-popup>

  </div>
</template>
<script>
    export default {
        props: ['datalist', 'header'],
        data () {
            return {
                selItem: {},
                show: false
            }
        },
        methods: {
            init (item) {
                this.show = true
                if (item) {
                    this.selItem = item
                }
            },
            // 点击列表项
            selectItem (item) {
                this.selItem = item
                // this.$emit('select', this.selItem)
                this.close()
            },
            close () {
                this.show = false
                this.$emit('close', this.selItem)
            }
        }
    }
</script>

<style lang="less" scoped>
  .box {
    padding: 0 16px;
    .header {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      .close-icon{
        width: 12px;
        height: 12px;
      }
      .title {
        font-size: 16px;
        color: #171a1d;
        font-weight: 600;
      }
    }
    .tab-box {
      display: flex;
      border-bottom: 1px solid #f5f6f9;
      padding-top: 11px;
      .tab {
        margin-right: 21px;
        font-size: 14px;
        color: #666666;
        padding-bottom: 14.5px;
      }
      .tab-active {
        margin-right: 21px;
        font-size: 14px;
        color: #171a1d;
        padding-bottom: 14.5px;
        border-bottom: 1px solid #36b374;
      }
    }
    .person-list {
      max-height: 350px;
      overflow: auto;
      padding-bottom: 50px;
      &::-webkit-scrollbar {
        display: none;
      }
      .person-item {
        padding: 20.5px 0;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f6f9;
        .name {
          font-size: 16px;
          color: #171A1D;
          font-weight: 400;
        }
        .select-icon {
          width: 18px;
          height: 18px;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      padding-bottom: 87px;
      img {
        display: inline-block;
        width: 74px;
        height: 62px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
</style>
